export const getNfseConfigurations = (state) => state.nfseConfigurations;
